/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import { Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { MenuItem } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
// IMPORT CUSTOM COMPONENT
import moment from 'moment';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import { checksGridTableHead } from './gridComponents/tableHead';
// import custom function
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import {
  closeTab,
  getCommonDropdownList,
  handleScrollToEvent,
  redirectURLLink,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  filterChecksByRadioButtonList,
  AllocateFromRadioButtonList,
  tableGridHight350,
} from '../../../../SharedModules/CommonConstants/commonConstants';
import {
  setSearchScreenTab,
  getGeneralSystemParameterDetails,
  dispatchFailedAPIError,
  setPerviousScreenReduxData,
  dispatchManufacturerData,
  setSearchPickInvoiceAssScreenTab,
  dispatchCheckAllocatePaymentDetails,
  handleErrorMessageForAllocatePayment,
  getCheckAllocatePaymentDetails,
  getLoggedByOtherUserList,
  setErrorMessageForSearch,
} from '../store/Actions';
import { tabHighLigther } from '../../../../SharedModules/utilities/utilities';
import DateRangeRender from './gridComponents/DateRangeRender';
import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';

const SearchAllocatePaymentComponent = React.memo(() => {
  const dispatch = useDispatch();
  const history = useHistory();
  // use Selector function
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const searchScreenTabData = useSelector(
    (state) => state.sharedState.AllocatePaymentReducer?.searchScreenObj
  );
  const allocatePaymentChecksGridData = useSelector((state) => {
    return state.sharedState.AllocatePaymentReducer?.checksGridList?.sort(
      (a, b) => a.checkLogNum - b.checkLogNum
    );
  });
  const errorMessagesFromRedux = useSelector(
    (state) => state?.sharedState?.AllocatePaymentReducer?.errorMessagesInRedux
  );
  const failedAPIResponse = useSelector(
    (state) => state?.sharedState?.AllocatePaymentReducer?.failedAPIMsg
  );
  const UserDefaultValues = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const generalSystemParameterDetails = useSelector((state) => {
    return state.sharedState.AllocatePaymentReducer.generalSystemParameter
      ?.paramGeneralVO;
  });
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  // variable deceleration
  const gridRef = React.useRef();
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [gridParams, setGridParams] = React.useState(null);
  const [selectedRow, setSelectedRow] = React.useState({});
  const [commonDropdownList, setCommonDropdownList] = React.useState([]);
  const [loggedByOtherUserList, setLoggedByOtherUserList] = React.useState([]);
  const [keyValue, setKeyValue] = React.useState([]);
  const [showViewHistory, setShowViewHistory] = React.useState(false);
  const [state, setState] = React.useState(
    searchScreenTabData?.state
      ? searchScreenTabData.state
      : {
          allocateFrom: 'Check',
          checkPayeeCd: UserDefaultValues?.checkPayeeCd
            ? UserDefaultValues?.checkPayeeCd
            : '',
          filterChecksBy: 'noFilter',
          loggedByOther: '-1',
          fromDate: null,
          toDate: null,
        }
  );
  const [pendingGridSelection, setPendingGridSelection] = React.useState(null); // for deferred grid selection

  // check grid data come after 1st row selected.
  React.useEffect(() => {
    if (
      allocatePaymentChecksGridData &&
      allocatePaymentChecksGridData?.length > 0
    ) {
      if (gridParams !== null) {
        dispatch(
          setSearchScreenTab({
            ...searchScreenTabData,
            currentIndex: searchScreenTabData?.currentIndex || 0,
            selectedRow:
              searchScreenTabData?.selectedRow ||
              allocatePaymentChecksGridData[0],
          })
        );
        if (searchScreenTabData?.selectedRow) {
          setSelectedRow(searchScreenTabData?.selectedRow);
        } else {
          setSelectedRow(allocatePaymentChecksGridData[0]);
        }
        setPendingGridSelection({
          index: searchScreenTabData?.currentIndex || 0,
          selectedRow:
            searchScreenTabData?.selectedRow ||
            allocatePaymentChecksGridData[0],
        });
      }
    }
  }, [allocatePaymentChecksGridData]);
  // handing refresh functionality
  React.useEffect(() => {
    if (searchScreenTabData && Object.keys(searchScreenTabData).length > 0) {
      setSelectedRow(searchScreenTabData?.selectedRow);
      if (gridParams !== null) {
        setPendingGridSelection({
          index: searchScreenTabData.currentIndex,
          selectedRow: searchScreenTabData.selectedRow,
        });
      }
    }
  }, [searchScreenTabData]);

  // handing by default first row selection function
  const onGridReady = (params) => {
    setGridParams(params);
    params.api.forEachNode(
      (node) =>
        node.rowIndex === searchScreenTabData.currentIndex &&
        node.setSelected(true)
    );
  };
  // click on filter icon after call
  const handleClearFilter = () => {
    if (gridRef !== null) {
      if (gridRef.current?.clearFilters) gridRef.current.clearFilters();
      if (gridParams?.columnApi && gridParams?.columnApi !== null) {
        gridParams.columnApi.applyColumnState({
          state: [{ colId: 'checkLogNum', sort: 'asc' }],
        });
      }
    }
  };
  // handing highlight tab
  React.useEffect(() => {
    if (
      errorMessagesFromRedux?.searchScreenErrors?.length > 0 &&
      state.allocateFrom === 'Check'
    ) {
      tabHighLigther('/allocatePayment', true);
    } else {
      tabHighLigther('/allocatePayment', false);
    }
  }, [JSON.stringify(errorMessagesFromRedux?.searchScreenErrors)]);

  // click on full screen icon after call in Check grid
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
    dispatch(
      setSearchScreenTab({
        ...searchScreenTabData,
        fullScreenView: !fullScreenView,
      })
    );
  };
  React.useEffect(() => {
    if (
      state.filterChecksBy === 'checkDt' ||
      state.filterChecksBy === 'batchDt' ||
      state.filterChecksBy === 'receivedDt' ||
      state.filterChecksBy === 'postmarkedDt'
    ) {
      if (state.fromDate && state.toDate) {
        handleSearchForChecksGrid('dateFilter');
      }
    } else {
      handleSearchForChecksGrid(state.filterChecksBy);
    }
  }, []);
  // check payee cd dropdown change Check Grid API service call
  const handleSearchForChecksGrid = (name, value) => {
    let localErr = errorMessagesFromRedux?.searchScreenErrors || [];
    dispatch(dispatchCheckAllocatePaymentDetails([]));
    const checkPayeeCdVal =
      name === 'checkPayeeCd' ? value : state.checkPayeeCd;
    const userId = UserDefaultValues?.userId
      ? UserDefaultValues?.userId
      : logInUser;
    if (
     checkPayeeCdVal && checkPayeeCdVal !== "-1"
    ) {
      localErr = localErr.filter(
        (item) =>
          item.field !== 'loggedByOther' &&
          item.field !== 'checkPayeeCd' &&
          item.field !== 'fromDate' &&
          item.field !== 'toDate' &&
          item.field !== 'resultNotFound'
      );
      let loggedByOtherDropDOwnVal = null;
      if (name === 'loggedByOther' && value) {
        loggedByOtherDropDOwnVal = value;
      } else if (
        state.filterChecksBy === 'loggedByOther' &&
        name !== 'noFilter'
      ) {
        loggedByOtherDropDOwnVal = state.loggedByOther;
      }
      if (name === 'loggedByMe') {
        loggedByOtherDropDOwnVal = null;
      }
      if (loggedByOtherDropDOwnVal !== '-1') {
        handleClearFilter();
        dispatch(
          getCheckAllocatePaymentDetails({
            checkPayeeCd: checkPayeeCdVal,
            loggedByMe:
              name === 'loggedByMe' ||
              (state.filterChecksBy === 'loggedByMe' && name !== 'noFilter')
                ? userId
                : null,
            loggedByOther:
              loggedByOtherDropDOwnVal === '-1'
                ? null
                : loggedByOtherDropDOwnVal,
            batchDt:
              state.filterChecksBy === 'batchDt' && name === 'dateFilter'
                ? moment(state.fromDate).format('MM/DD/YYYY')
                : null,
            toBatchDt:
              state.filterChecksBy === 'batchDt' && name === 'dateFilter'
                ? moment(state.toDate).format('MM/DD/YYYY')
                : null,
            checkDt:
              state.filterChecksBy === 'checkDt' && name === 'dateFilter'
                ? moment(state.fromDate).format('MM/DD/YYYY')
                : null,
            toCheckDt:
              state.filterChecksBy === 'checkDt' && name === 'dateFilter'
                ? moment(state.toDate).format('MM/DD/YYYY')
                : null,
            postmarkedDt:
              state.filterChecksBy === 'postmarkedDt' && name === 'dateFilter'
                ? moment(state.fromDate).format('MM/DD/YYYY')
                : null,
            toPostmarkedDt:
              state.filterChecksBy === 'postmarkedDt' && name === 'dateFilter'
                ? moment(state.toDate).format('MM/DD/YYYY')
                : null,
            receivedDt:
              state.filterChecksBy === 'receivedDt' && name === 'dateFilter'
                ? moment(state.fromDate).format('MM/DD/YYYY')
                : null,
            toReceivedDt:
              state.filterChecksBy === 'receivedDt' && name === 'dateFilter'
                ? moment(state.toDate).format('MM/DD/YYYY')
                : null,
          })
        );
      }
    } else if (!checkPayeeCdVal || checkPayeeCdVal === '-1') {
      localErr = localErr.filter(
        (item) =>
          item.field !== 'checkPayeeCd' && item.field !== 'resultNotFound'
      );
      localErr.push({
        field: 'checkPayeeCd',
        errorType: 'checkPayeeCdRequired',
        message: constantMessageData.CHECKS_PAYEE_REQUIRED,
      });
    }
    dispatch(
      handleErrorMessageForAllocatePayment({
        ...errorMessagesFromRedux,
        searchScreenErrors: [...new Set(localErr)],
      })
    );
  };
  // handling onPage load call service
  React.useEffect(() => {
    handleScrollToEvent();
    dispatch(getGeneralSystemParameterDetails());
    dispatch(dispatchFailedAPIError(null));
    getCommonDropdownList({
      codeDomainList: ['CHECK_PAYEE_CD', 'DISPUTE_RESOLUTION_CD'],
    }).then((res) => {
      setCommonDropdownList(res);
    });
    getLoggedByOtherUserList('').then((res) => {
      setLoggedByOtherUserList(res);
    });
    if (!allocatePaymentChecksGridData?.length > 0) {
      handleSearchForChecksGrid('noFilter');
    }
  }, []);
  // handing On change event on filed level
  const handleOnChangeEvent = (value, name) => {
    let localErr = errorMessagesFromRedux?.searchScreenErrors || [];

    if (name === 'checkPayeeCd') {
      if (!value || value === '-1') {
        localErr = localErr.filter(
          (item) =>
            item.field !== 'checkPayeeCd' && item.field !== 'resultNotFound'
        );
        localErr.push({
          field: 'checkPayeeCd',
          errorType: 'checkPayeeCdRequired',
          message: constantMessageData.CHECKS_PAYEE_REQUIRED,
        });
      } else {
        localErr = localErr.filter(
          (item) =>
            item.field !== 'checkPayeeCd' && item.field !== 'resultNotFound'
        );
      }
    }
    if (name === 'loggedByOther') {
      if (!value || value === '-1') {
        localErr = localErr.filter(
          (item) =>
            item.field !== 'loggedByOther' && item.field !== 'resultNotFound'
        );
        localErr.push({
          field: 'loggedByOther',
          errorType: 'loggedByOtherRequired',
          message: constantMessageData.LOGGED_BY_REQUIRED,
        });
      } else {
        localErr = localErr.filter(
          (item) =>
            item.field !== 'loggedByOther' &&
            item.field !== 'fromDate' &&
            item.field !== 'toDate' &&
            item.field !== 'resultNotFound'
        );
      }
    }

    if (name === 'loggedByOther' || name === 'checkPayeeCd') {
      handleSearchForChecksGrid(name, value);
    }
    if (name === 'filterChecksBy') {
      localErr = localErr.filter(
        (item) =>
          item.field !== 'loggedByOther' &&
          item.field !== 'fromDate' &&
          item.field !== 'toDate' &&
          item.field !== 'resultNotFound'
      );
      setState({
        ...state,
        [name]: value,
        loggedByOther: '-1',
        fromDate: null,
        toDate: null,
      });
      dispatch(
        setSearchScreenTab({
          ...searchScreenTabData,
          state: {
            ...state,
            [name]: value,
            loggedByOther: '-1',
            fromDate: null,
            toDate: null,
          },
        })
      );
    } else {
      setState({ ...state, [name]: value });
      dispatch(
        setSearchScreenTab({
          ...searchScreenTabData,
          state: { ...state, [name]: value },
        })
      );
    }

    dispatch(
      handleErrorMessageForAllocatePayment({
        ...errorMessagesFromRedux,
        searchScreenErrors: [...new Set(localErr)],
      })
    );
  };
  // check validation function
  const validateRequest = () => {
    const localErr = [];
    let checkValidation = false;
    if (
      state.checkPayeeCd === '-1' ||
      state.checkPayeeCd === null ||
      ((state.loggedByOther === '-1' || state.loggedByOther === null) &&
        state.filterChecksBy === 'loggedByOther')
    ) {
      if (state.checkPayeeCd === '-1' || state.checkPayeeCd === null) {
        checkValidation = true;
        localErr.push({
          field: 'checkPayeeCd',
          errorType: 'checkPayeeCdRequired',
          message: constantMessageData.CHECKS_PAYEE_REQUIRED,
        });
      }
      if (
        (state.loggedByOther === '-1' || state.loggedByOther === null) &&
        state.filterChecksBy === 'loggedByOther'
      ) {
        checkValidation = true;
        localErr.push({
          field: 'loggedByOther',
          errorType: 'loggedByOtherRequired',
          message: constantMessageData.LOGGED_BY_REQUIRED,
        });
      }
    } else if (
      allocatePaymentChecksGridData?.length <= 0 ||
      gridParams?.api?.getDisplayedRowCount() <= 0
    ) {
      checkValidation = true;
      localErr.push({
        field: 'resultNotFound',
        errorType: 'resultNotFound',
        message: constantMessageData.NO_SELECTED_ANY_CHECK,
      });
    }
    dispatch(
      handleErrorMessageForAllocatePayment({
        ...errorMessagesFromRedux,
        searchScreenErrors: [...new Set(localErr)],
      })
    );
    return !checkValidation;
  };
  // redirect to Pick an Invoice to Associate with this check screen
  const handleViewDetailFunction = (row) => {
    const localErr = [];
    if (validateRequest()) {
      const rowIndex = allocatePaymentChecksGridData?.findIndex((x) => {
        return x.checkLogNum === row?.checkLogNum;
      });
      if (selectedRow?.checkLogNum || row?.checkLogNum) {
        dispatch(
          setSearchScreenTab({
            ...searchScreenTabData,
            state: state,
            selectedRow: row,
            currentIndex: rowIndex,
          })
        );
        dispatch(setSearchPickInvoiceAssScreenTab({}));
        dispatch(dispatchManufacturerData([]));
        dispatch(
          setPerviousScreenReduxData({
            ...searchScreenTabData,
            state: state,
            selectedRow: row,
            currentIndex: rowIndex,
          })
        );
        tabHighLigther('/allocatePayment', false);
        dispatch(setErrorMessageForSearch([]));
        const tabItemsData = JSON.parse(
          localStorage.getItem('tabsItemsData') || '[]'
        );
        const tabIndex = tabItemsData.findIndex(
          (tab) => tab.navTo === '/pickInvoiceAssociateWithCheck'
        );
        if (tabIndex !== -1) {
          tabItemsData[
            tabIndex
          ].value = `Pick an Invoice to Associate with this Check (${row.checkLogNum})`;
          localStorage.setItem('tabItemsData', JSON.stringify(tabItemsData));
        }
        //closeTab('/pickInvoiceAssociateWithCheck', history);
        redirectURLLink(
          '/pickInvoiceAssociateWithCheck',
          `Pick an Invoice to Associate with this Check (${row.checkLogNum})`,
          history,
          dispatch
        );
      } else {
        localErr.push({
          field: 'resultNotFound',
          errorType: 'resultNotFound',
          message: constantMessageData.NO_SELECTED_ANY_CHECK,
        });
      }
      dispatch(
        handleErrorMessageForAllocatePayment({
          ...errorMessagesFromRedux,
          searchScreenErrors: [...new Set(localErr)],
        })
      );
    }
  };
  // user select credit option after redirect to Pick an Invoice to Associate with this check screen
  const handleViewDetailFunctionCredit = (row) => {
    dispatch(
      setSearchScreenTab({
        ...searchScreenTabData,
        state: state,
        selectedRow: row,
      })
    );
    dispatch(setSearchPickInvoiceAssScreenTab({}));
    dispatch(dispatchManufacturerData([]));
    dispatch(
      setPerviousScreenReduxData({
        ...searchScreenTabData,
        state: state,
        selectedRow: row,
      })
    );
    tabHighLigther('/allocatePayment', false);
    dispatch(setErrorMessageForSearch([]));
    //closeTab('/pickInvoiceAssociateWithCheck', history);
    redirectURLLink(
      '/pickInvoiceAssociateWithCheck',
      `Pick an Invoice to Associate with this Check (${0})`,
      history,
      dispatch
    );
  };
  // set Initial state values
  React.useEffect(() => {
    if (Object.keys(searchScreenTabData)?.length !== 0) {
      const tempObj = searchScreenTabData;
      if (tempObj?.fullScreenView) setFullScreenView(tempObj.fullScreenView);
    }
  }, [searchScreenTabData]);
  // set Default first row selected on page load
  const handleDefaultRow = () => {
    let localErr = errorMessagesFromRedux?.searchScreenErrors || [];
    localErr = localErr.filter((x) => x.field !== 'resultNotFound');
    dispatch(
      handleErrorMessageForAllocatePayment({
        ...errorMessagesFromRedux,
        searchScreenErrors: [...new Set(localErr)],
      })
    );
    setSelectedRow(allocatePaymentChecksGridData[0]);
    dispatch(
      setSearchScreenTab({
        ...searchScreenTabData,
        currentIndex: 0,
        state: state,
        selectedRow: allocatePaymentChecksGridData[0],
      })
    );
    if (gridParams !== null) {
      setPendingGridSelection({
        index: 0,
        selectedRow: allocatePaymentChecksGridData[0],
      });
    }
  };

  const handleViewHistory = (gridApi) => {
    const selectedRow = gridApi.getSelectedRows()?.[0]?.checkLogNum;
    setShowViewHistory(true);
    if (selectedRow !== undefined) {
      setKeyValue({ CHECK_LOG_NUM: selectedRow });
    }
  };

  // Add useEffect to handle pendingGridSelection
  React.useEffect(() => {
    if (pendingGridSelection && gridParams !== null) {
      gridParams.api.forEachNode(
        (node) =>
          node.rowIndex === pendingGridSelection.index && node.setSelected(true)
      );
      setPendingGridSelection(null);
    }
  }, [pendingGridSelection, gridParams]);

  return (
    <div
      className=" tBillPanel padding-0 tabs-container"
      data-testid="allocate-payment-search-component"
    >
      <CustomSeparator parent1="Tasks" parent2="Allocate Payments" />
      {!fullScreenView && (
        <>
          {failedAPIResponse && failedAPIResponse !== null ? (
            <DisplayErrorMessages errorMessages={[failedAPIResponse]} />
          ) : (
            state.allocateFrom === 'Check' && (
              <DisplayErrorMessages
                errorMessages={[
                  ...new Set(
                    errorMessagesFromRedux?.searchScreenErrors?.length > 0
                      ? _.map(
                          errorMessagesFromRedux.searchScreenErrors,
                          (l) => l.message
                        )
                      : []
                  ),
                ]}
              />
            )
          )}
        </>
      )}
      <Spinner load={spinnerLoader} />
      <div className="no-margin">
        {!fullScreenView && (
          <div className="row mb-2">
            <div className="col-12 col-sm-6 col-md-6 col-lg-6 mt-sm-3 mt-md-0 frr-no-wrap frr-radio-40per-width">
              <RadioGroupComponent
                data-testid="filter-plan-by-radio-btn-plan"
                id="filter-plan-by-radio-btn-action"
                labelName="Allocate From"
                required
                reqColor
                optionList={AllocateFromRadioButtonList}
                defaultValue={state && state.allocateFrom}
                filterAction={(e) => {
                  handleOnChangeEvent(e, 'allocateFrom');
                  if (e === 'Check') {
                    if (
                      errorMessagesFromRedux?.searchScreenErrors?.length > 0
                    ) {
                      tabHighLigther('/allocatePayment', true);
                    }
                    setSelectedRow({});
                    if (allocatePaymentChecksGridData?.length > 0) {
                      handleDefaultRow();
                    }
                  } else {
                    tabHighLigther('/allocatePayment', false);
                    setSelectedRow({
                      checkLogNum: 0,
                      checkPayeeCd: null,
                      checkAmt: 0,
                    });
                  }
                }}
                className="log-batch-filter-radio"
              />
            </div>
            {state?.allocateFrom === 'Check' && (
              <div className="col-12 col-sm-6 col-md-6 col-lg-6 mt-sm-3 mt-md-0 frr-no-wrap">
                <fieldset className="custom-fieldset">
                  <legend className="same-font-family">
                    Checks for Payee
                    <span className="mandatory">
                      {state?.allocateFrom === 'Check' ? ' *' : ''}
                    </span>{' '}
                  </legend>
                  <div className="form-wrapper no-lbl">
                    <div className="mui-custom-form with-select">
                      <TextField
                        data-testid="rebate_program-generate-inv"
                        id="checkPayeeCd"
                        // className="frr-display-hidden-label"
                        label="Checks for Payee"
                        fullWidth
                        select
                        required
                        placeholder=""
                        inputProps={{ maxLength: 11, id: 'checkPayeeCd' }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={state && state.checkPayeeCd}
                        onChange={(e) =>
                          handleOnChangeEvent(e.target.value, 'checkPayeeCd')
                        }
                        className={`frr-display-hidden-label ${
                          errorMessagesFromRedux?.searchScreenErrors?.length > 0
                            ? _.map(
                                errorMessagesFromRedux.searchScreenErrors,
                                (l) =>
                                  l.field === 'checkPayeeCd'
                                    ? 'mandate-fields'
                                    : null
                              )
                            : null
                        }`}
                        helperText={
                          errorMessagesFromRedux?.searchScreenErrors?.length > 0
                            ? _.map(
                                errorMessagesFromRedux.searchScreenErrors,
                                (l) =>
                                  l.field === 'checkPayeeCd' ? l.message : null
                              )
                            : null
                        }
                        error={
                          errorMessagesFromRedux?.searchScreenErrors?.length > 0
                            ? _.map(
                                errorMessagesFromRedux.searchScreenErrors,
                                (l) =>
                                  l.field === 'checkPayeeCd' ? l.message : null
                              )
                            : null
                        }
                      >
                        <MenuItem
                          key=""
                          value="-1"
                          className="frr-dropdown-blank-item"
                        />
                        <MenuItem selected key="All" value="ALL">
                          All
                        </MenuItem>

                        {commonDropdownList &&
                          commonDropdownList?.CHECK_PAYEE_CD?.map((item) => {
                            return (
                              <MenuItem
                                key={
                                  item.codeValueID && item.codeValueID.codeValue
                                }
                                value={
                                  item.codeValueID && item.codeValueID.codeValue
                                }
                              >
                                {`${
                                  item.codeValueID && item.codeValueID.codeValue
                                } - ${item.shortDescription}`}
                              </MenuItem>
                            );
                          })}
                      </TextField>
                    </div>
                  </div>
                </fieldset>
              </div>
            )}
          </div>
        )}
        {state?.allocateFrom === 'Check' && !fullScreenView && (
          <div className="row mb-2 mt-3">
            <div
              className={
                state.filterChecksBy === 'loggedByOther' ? 'col-6' : 'col-12'
              }
            >
              <RadioGroupComponent
                data-testid="filter-plan-by-radio-btn-plan1"
                id="filter-plan-by-radio-btn-action"
                labelName="Filter Checks By"
                required
                reqColor
                optionList={filterChecksByRadioButtonList}
                defaultValue={state && state.filterChecksBy}
                filterAction={(e) => {
                  handleOnChangeEvent(e, 'filterChecksBy');
                  if (
                    e === 'loggedByOther' ||
                    e === 'checkDt' ||
                    e === 'postmarkedDt' ||
                    e === 'batchDt' ||
                    e === 'receivedDt'
                  ) {
                    dispatch(dispatchCheckAllocatePaymentDetails([]));
                  } else {
                    handleSearchForChecksGrid(e);
                  }
                }}
                className="log-batch-filter-radio"
              />
            </div>
            {state?.filterChecksBy === 'loggedByOther' && (
              <div className="col-12 col-sm-6 col-md-6 col-lg-6 mt-md-0 frr-no-wrap no-lbl">
                <fieldset className="custom-fieldset">
                  <legend className="same-font-family">
                    Logged By
                    <span className="mandatory">
                      {state?.allocateFrom === 'Check' ? ' *' : ''}
                    </span>{' '}
                  </legend>
                  <div className="form-wrapper">
                    <div className="mui-custom-form with-select">
                      <TextField
                        data-testid="rebate_program-generate-inv1"
                        id="loggedByOther"
                        label=""
                        fullWidth
                        select
                        required
                        placeholder=""
                        inputProps={{ maxLength: 11, id: 'loggedByOther' }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={state && state.loggedByOther}
                        onChange={(e) =>
                          handleOnChangeEvent(e.target.value, 'loggedByOther')
                        }
                        className={
                          errorMessagesFromRedux?.searchScreenErrors?.length > 0
                            ? _.map(
                                errorMessagesFromRedux.searchScreenErrors,
                                (l) =>
                                  l.field === 'loggedByOther'
                                    ? 'mandate-fields'
                                    : null
                              )
                            : null
                        }
                        helperText={
                          errorMessagesFromRedux?.searchScreenErrors?.length > 0
                            ? _.map(
                                errorMessagesFromRedux.searchScreenErrors,
                                (l) =>
                                  l.field === 'loggedByOther' ? l.message : null
                              )
                            : null
                        }
                        error={
                          errorMessagesFromRedux?.searchScreenErrors?.length > 0
                            ? _.map(
                                errorMessagesFromRedux.searchScreenErrors,
                                (l) =>
                                  l.field === 'loggedByOther' ? l.message : null
                              )
                            : null
                        }
                      >
                        <MenuItem
                          key=""
                          value="-1"
                          className="frr-dropdown-blank-item"
                        />

                        {loggedByOtherUserList &&
                          loggedByOtherUserList
                            ?.filter((x) => {
                              return x.lastUpdateUserId !== logInUser;
                            })
                            ?.map((item) => {
                              return (
                                <MenuItem
                                  key={item.lastUpdateUserId}
                                  value={item.lastUpdateUserId}
                                >
                                  {item.lastUpdateUserId}
                                </MenuItem>
                              );
                            })}
                      </TextField>
                    </div>
                  </div>
                </fieldset>
              </div>
            )}
            {(state?.filterChecksBy === 'checkDt' ||
              state?.filterChecksBy === 'postmarkedDt' ||
              state?.filterChecksBy === 'receivedDt' ||
              state?.filterChecksBy === 'batchDt') && (
              <div className="col-12  mt-3">
                <fieldset className="custom-fieldset">
                  <legend className="same-font-family">
                    {`Date Range-${
                      state?.filterChecksBy === 'checkDt'
                        ? 'Check Date'
                        : state?.filterChecksBy === 'postmarkedDt'
                        ? 'Postmark Date'
                        : state?.filterChecksBy === 'receivedDt'
                        ? 'Received Date'
                        : state?.filterChecksBy === 'batchDt'
                        ? 'Batch Date'
                        : ''
                    }`}
                    <span className="mandatory">
                      {state?.allocateFrom === 'Check' ? ' *' : ''}
                    </span>{' '}
                  </legend>
                  <DateRangeRender
                    state={state}
                    setState={setState}
                    handleSearchForChecksGrid={handleSearchForChecksGrid}
                  />
                </fieldset>
              </div>
            )}
          </div>
        )}
        <div className="row mb-2">
          <div className="col-12">
            {!fullScreenView && (
              <div className="text-right">
                <Button
                  className="btn btn-success btn-search"
                  data-testid="resume-btn"
                  type="button"
                  onClick={() => {
                    if (state?.allocateFrom === 'Check') {
                      handleViewDetailFunction(selectedRow);
                    } else {
                      handleViewDetailFunctionCredit({
                        checkLogNum: 0,
                        checkPayeeCd: null,
                        checkAmt: 0,
                      });
                    }
                  }}
                >
                  {'  '} Allocate
                </Button>
              </div>
            )}
            {state?.allocateFrom === 'Check' && (
              <>
                <TableGrid
                  ref={gridRef}
                  gridCall={onGridReady}
                  data-testid="manufacturer-ia-table"
                  rowSelection="single"
                  rowMultiSelectWithClick={false}
                  fullScreenView={fullScreenView}
                  handleFullScreenViewClick={handleFullScreenView}
                  gridHeight={fullScreenView ? '70vh' : tableGridHight350}
                  rowData={
                    allocatePaymentChecksGridData &&
                    allocatePaymentChecksGridData?.map((item) => {
                      const firstDropdownVal =
                        commonDropdownList?.CHECK_PAYEE_CD?.filter((x) => {
                          return (
                            x.codeValueID &&
                            x.codeValueID?.codeValue === item.checkPayeeCd
                          );
                        });
                      if (firstDropdownVal && firstDropdownVal.length > 0) {
                        item.checkPayeeCd = `${
                          firstDropdownVal[0].codeValueID &&
                          firstDropdownVal[0].codeValueID.codeValue
                        } - ${firstDropdownVal[0].shortDescription}`;
                      }
                      const thirdDropDownVal =
                        commonDropdownList?.DISPUTE_RESOLUTION_CD?.filter(
                          (x) => {
                            return (
                              x.codeValueID &&
                              x.codeValueID?.codeValue ===
                                item.disputeResolutionCd
                            );
                          }
                        );
                      if (thirdDropDownVal && thirdDropDownVal.length > 0) {
                        item.disputeResolutionCd = `${
                          thirdDropDownVal[0].codeValueID &&
                          thirdDropDownVal[0].codeValueID.codeValue
                        } - ${thirdDropDownVal[0].shortDescription}`;
                      }
                      return item;
                    })
                  }
                  columnDefs={checksGridTableHead?.filter((x) => {
                    if (
                      generalSystemParameterDetails &&
                      parseInt(
                        generalSystemParameterDetails[0]?.checkLogByCcnInd,
                        [0, 1]
                      ) === 0
                    ) {
                      return x.field !== 'checkIdentifier';
                    }
                    if (
                      generalSystemParameterDetails &&
                      parseInt(
                        generalSystemParameterDetails[0]?.checkLogUsesBatchInd,
                        [0, 1]
                      ) === 0
                    ) {
                      return x.field !== 'batchNum' && x.field !== 'batchDt';
                    }
                    return x;
                  })}
                  exportFile
                  animateRows
                  sideBar={false}
                  isScrollOn
                  helpMessage="* On Double Click of Results, system should navigate to Detail page"
                  fileName="Allocate Payment-Check Grid"
                  singleClickEdit
                  onFilterData={(data, val) => {
                    if (val === 'clearFilter') {
                      handleDefaultRow();
                    }
                  }}
                  navigateToNextCell={navigateToNextCell}
                  tabToNextCell={tabToNextCell}
                  enterMovesDown
                  suppressCellFocus
                  onCellFocused={onCellFocused}
                  onSelect={(e) => {
                    setSelectedRow(e.data);
                  }}
                  cellClickedListener={(e) => {
                    handleViewDetailFunction(e.data);
                  }}
                  frameworkComponents={{
                    NameRenderCheckIssuer: (cellInfo) => {
                      const name = cellInfo?.data?.checkIssuer;
                      if (name && name.length > 22) {
                        return (
                          <OverlayTrigger
                            placement="bottom"
                            overlay={
                              <Tooltip id="labeler-tooltip">{name}</Tooltip>
                            }
                          >
                            <div>{name}</div>
                          </OverlayTrigger>
                        );
                      }
                      return <div>{name}</div>;
                    },
                    NameRenderCheckIdentifier: (cellInfo) => {
                      const name = cellInfo?.data?.checkIdentifier;
                      if (name && name.length > 15) {
                        return (
                          <OverlayTrigger
                            placement="bottom"
                            overlay={
                              <Tooltip id="labeler-tooltip">{name}</Tooltip>
                            }
                          >
                            <div>{name}</div>
                          </OverlayTrigger>
                        );
                      }
                      return <div>{name}</div>;
                    },
                    NameRenderBatchNum: (cellInfo) => {
                      const name = cellInfo?.data?.batchNum;
                      if (name && name.length > 15) {
                        return (
                          <OverlayTrigger
                            placement="bottom"
                            overlay={
                              <Tooltip id="labeler-tooltip">{name}</Tooltip>
                            }
                          >
                            <div>{name}</div>
                          </OverlayTrigger>
                        );
                      }
                      return <div>{name}</div>;
                    },
                    NameRenderInformation: (cellInfo) => {
                      const name = cellInfo?.data?.checkInfo;
                      if (name && name.length > 15) {
                        return (
                          <OverlayTrigger
                            placement="bottom"
                            overlay={
                              <Tooltip id="labeler-tooltip">{name}</Tooltip>
                            }
                          >
                            <div>{name}</div>
                          </OverlayTrigger>
                        );
                      }
                      return <div>{name}</div>;
                    },
                    CheckAmtCellRender: (cellInfo) => {
                      const isNegativeVal = !(
                        parseFloat(
                          cellInfo?.data?.checkAmt?.toString().split('$')[1]
                        ) >= 0
                      );
                      return (
                        <>
                          {isNegativeVal ? (
                            <div
                              style={{ color: '#eb0000' }}
                            >{`(${cellInfo?.data?.checkAmt
                              ?.toString()
                              ?.replace('-', '')
                              .trim()})`}</div>
                          ) : (
                            <div>{`${cellInfo?.data?.checkAmt}`}</div>
                          )}
                        </>
                      );
                    },
                    TotAllocatedAmtCellRender: (cellInfo) => {
                      const isNegativeVal = !(
                        parseFloat(
                          cellInfo?.data?.totAllocatedAmt
                            ?.toString()
                            .split('$')[1]
                        ) >= 0
                      );
                      return (
                        <>
                          {isNegativeVal ? (
                            <div
                              style={{ color: '#eb0000' }}
                            >{`(${cellInfo?.data?.totAllocatedAmt
                              ?.toString()
                              ?.replace('-', '')
                              .trim()})`}</div>
                          ) : (
                            <div>{`${cellInfo?.data?.totAllocatedAmt}`}</div>
                          )}
                        </>
                      );
                    },
                  }}
                  handleViewHistory={handleViewHistory}
                />
                <div className="row mb-2 ml-1">
                  <b>Note:</b>Checks that are fully allocated and suspended
                  status will not be listed in this screen.
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      {showViewHistory && (
        <ViewHistoryComponent
          setShowViewHistory={setShowViewHistory}
          tableName="CHECK_LOG"
          keyValue={keyValue}
        />
      )}
    </div>
  );
});
export default SearchAllocatePaymentComponent;
